import { createContext, useContext, useState } from 'react';

const DEFAULT = {
  ids: [],
  toggle: () => {},
  isWishlisted: () => false,
};

const WishlistContext = createContext(DEFAULT);

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem('aurora_wishlist') || '[]'); } catch { return []; }
  });

  function toggle(id) {
    setIds(prev => {
      const next = prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id];
      localStorage.setItem('aurora_wishlist', JSON.stringify(next));
      return next;
    });
  }

  const isWishlisted = (id) => ids.includes(id);

  return (
    <WishlistContext.Provider value={{ ids, toggle, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() { return useContext(WishlistContext); }